import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 78"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M45.676 0C33.78 0 21.906 3.472 13.245 10.425h-.343v.28C5.103 17.111 0 26.398 0 38.572 0 64.31 22.805 77.147 45.676 77.147c22.87 0 45.61-12.837 45.61-38.574S68.481 0 45.676 0m3.974 73.432a22.3 22.3 0 0 1-22.35-22.35v-4.756h-3.257v4.757a25.52 25.52 0 0 0 12.588 22.084c-7.573-1.222-14.738-4.003-20.472-8.35V15.766l32.513 53.3h3.844V39.583c6.488-.65 12.51-5.201 12.51-13.651s-6.022-13-12.51-13.65V3.67c6.964.844 13.675 2.99 19.351 6.438v40.975c0 12.38-9.969 22.349-22.219 22.349zm2.867-58.045c4.847.64 9.252 4.154 9.252 10.545s-4.405 9.907-9.252 10.546zm-3.258 21.09c-4.847-.64-9.252-4.154-9.252-10.545 0-6.39 4.405-9.906 9.252-10.545zm0-33.107v8.911c-6.488.65-12.511 5.201-12.511 13.651s6.023 13.001 12.51 13.651v24.144L17.37 11.448c7.844-5.464 18.067-8.19 28.306-8.19q1.794.001 3.583.113zM3.257 38.573c0-9.906 3.737-17.72 9.643-23.454v46.908c-5.906-5.733-9.643-13.546-9.643-23.454m64.298 30.75c4.674-4.634 7.572-11.08 7.572-18.239V12.321C82.882 18.2 88.03 26.946 88.03 38.573c0 15.097-8.675 25.335-20.472 30.75z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M62.16 49.13c-1.107 0-1.954.848-1.954 1.89 0 1.173.847 2.02 1.954 2.02 1.108 0 1.955-.847 1.955-2.02 0-1.042-.847-1.89-1.955-1.89"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "MonogramTheNoJ"}) } }